import {useEffect, useState} from 'react';
import axios from 'axios';

// Module-level cache so every caller across the app shares one network request
// instead of each warehouse dropdown fetching /config/warehouse independently.
let cachedPromise = null;

function fetchWarehouses() {
    if (!cachedPromise) {
        cachedPromise = axios.get('/config/warehouse').then(r => r.data).catch(err => {
            cachedPromise = null;
            throw err;
        });
    }
    return cachedPromise;
}

// Returns the shared warehouse list as [{code, title}, ...], title already
// formatted (e.g. "Abbotsford") - use `title` for display, `code` for filtering.
export default function useWarehouses() {
    const [warehouses, setWarehouses] = useState([]);

    useEffect(() => {
        let active = true;
        fetchWarehouses().then(data => {
            if (active) setWarehouses(data);
        }).catch(() => {
        });
        return () => {
            active = false;
        };
    }, []);

    return warehouses;
}
